import { ACCOUNT, CALENDAR, RE_ASSURANCE } from "../../../HomeRepairFunnelV2/state-machine/configuration";
import { TotalMobileDisplayComponent } from "./TotalMobileDisplayComponent";
import { Box } from "@material-ui/core";
import { StyledGreyRectangle } from "../../../HomeRepairFunnelV2/Components/organisms/StepperFunnel/StepFunnelFooter";
import React from "react";
import { ResponsiveTotal } from "./RepairFunnelFooter";
import { Grid } from "../../../../ui/grid/Grid";
import { styled } from "@material-ui/core/styles";
import { Product } from "../../../../types/product";
import { getAmount } from "../../../HomeRepairFunnelV2/utils";
import Button from "../../../design-system/atoms/Button";

const ResponsiveButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontSize: "14px",
  },
}));

const AutoMarginGrid = styled(Grid)(() => ({
  marginTop: "auto",
  marginBottom: "auto",
}));

export const RepairFunnelFooterMobile = ({ state, shouldDisableContinueButton, gotoNextStep, shouldHideNext }) => {
  const { products }: { products: Product[] } = state?.context || { products: [] };
  return (
    <>
      <Grid item>
        {state && (state.matches(CALENDAR) || state.matches(ACCOUNT)) && (
          <TotalMobileDisplayComponent amount={getAmount(state)} products={products} />
        )}
        {state && !(state.matches(RE_ASSURANCE) || state.matches(CALENDAR) || state.matches(ACCOUNT)) && (
          <Box height="100%" display="flex" alignItems="center">
            <ResponsiveTotal mx={2} fontWeight="500">
              Total
            </ResponsiveTotal>
            <StyledGreyRectangle />
          </Box>
        )}
        {!state && <Box>&nbsp;</Box>}
      </Grid>
      {state && state.matches(RE_ASSURANCE) ? (
        <AutoMarginGrid item style={{ width: "100%" }}>
          <ResponsiveButton
            disabled={shouldDisableContinueButton}
            variant="contained"
            version="fancy"
            style={{ width: "100%" }}
            onClick={gotoNextStep}
          >
            Voir les disponibilités
          </ResponsiveButton>
        </AutoMarginGrid>
      ) : (
        <>
          {!shouldHideNext && (
            <AutoMarginGrid item>
              <ResponsiveButton
                disabled={shouldDisableContinueButton}
                variant="contained"
                version="fancy"
                onClick={gotoNextStep}
              >
                Continuer
              </ResponsiveButton>
            </AutoMarginGrid>
          )}
        </>
      )}
    </>
  );
};
